<article class="relatedPoint">
  <a
    class="relatedPoint__link"
    [class.relatedPoint__link--disabled]="ppIsNewPoint()"
    [attr.aria-label]="ppRelatedPoint().pointTitle"
    (click)="openPoint()"
    (keydown.enter)="openPoint()"
    tabindex="0"
  >
    @if (!ppIsNewPoint()) {
      <div class="relatedPoint__details">
        <span
          class="relatedPoint__priority"
          [ngClass]="priorityClass"
          [attr.aria-label]="'Priority: ' + ppRelatedPoint().pointPriority"
        >
        </span>
        <img
          class="relatedPoint__status"
          [src]="statusSrc"
          [attr.alt]="'Status: ' + ppRelatedPoint().pointStatus"
        />
      </div>
    }

    <span
      ppTooltip
      [ppTitle]="ppRelatedPoint().pointTitle"
      [ppTrimTooltip]="true"
      [attr.data-tooltip-title]="ppRelatedPoint().pointTitle"
      data-trim-tooltip="true"
      class="relatedPoint__title"
      data-testid="point-title"
      >{{ ppRelatedPoint().pointTitle }}</span
    >
  </a>

  @if (ppCanDelete()) {
    <button class="relatedPoint__delete" (click)="deleteRelation()" aria-label="Remove relation">
      <pp-icon [ppSVG]="iconMap[EIconPath.ICON_LINK_ATTACHMENT]"></pp-icon>
    </button>
  }
</article>
